import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  container: {
    border: `1px solid ${theme.palette.brand.greyWhite}`,
    borderLeft: `8px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  img: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  text: {
    color: theme.palette.primary.main,
    margin: theme.spacing(2),
    textAlign: 'start',
    lineHeight: '1.5',
    fontWeight: 600,
  },
}));

export default function InfoNote(props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img src={'./icons/info.svg'} className={classes.img} alt="info" />
      <Typography variant="subtitle1" className={classes.text}>
        {props.text}
      </Typography>
    </div>
  );
}
